import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductContentModule } from '../product-content/product-content.module';
import { SideNavComponent } from '../sidenav/sidenav.component';
import { ProductOverviewComponent } from './product-overview.component';
import { ProductOverViewRoutingModule } from './products-overview-routing.module';

@NgModule({
  declarations: [ProductOverviewComponent, SideNavComponent],
  imports: [ProductOverViewRoutingModule, ProductContentModule, CommonModule, FormsModule, ReactiveFormsModule],
  exports: [ProductOverviewComponent],
})
export class ProductOverviewModule {}
